//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            yuyuedingdan: [],
            is_show:false,
            is_close:false,
            qrcode_img:'https://api.pwmqr.com/qrcode/create/?url=',
            order_sn:'' ,
            active_id:'',
        }
    },
    created(){
        this.getList()
    },
    methods:{
        // 请求列表
        getList(){
            this.$HTTP
            .HttpPost("/Member/Appointment/getOrderList", {
            sid: this.popup_id,
            page: 1,
            quantity: 999,
            })
            .then((data) => {
                this.yuyuedingdan = data.data.data.data;
            });
        },
        // 取消预约
        async onCancel(item){
            // this.$HTTP
            // .HttpPost("/member/appointment/delOrder", {
            //     id:item.id
            // })
            // .then((data) => {
            //     if(data.data.code == 200){
            //         this.$vux.toast.show({
            //         text: data.data.msg,
            //         type: "text",
            //         width: "80%",
            //         isShowMask: true,
            //         })
            //     }
            //     this.getList()
            // });
            this.active_id = item.id
            this.is_close = true
            
        },
        // 确定取消预约
        async onCancel_y(){
            this.$HTTP
            .HttpPost("/member/appointment/delOrder", {
                id:this.active_id
            })
            .then((data) => {
                if(data.data.code == 200){
                    this.$vux.toast.show({
                    text: data.data.msg,
                    type: "text",
                    width: "80%",
                    isShowMask: true,
                    })
                }
                this.getList()
            });
            this.is_close = false
        },
        // 核销
        onQrcode(order_sn){
            this.order_sn = order_sn
            this.qrcode_img = 'https://api.pwmqr.com/qrcode/create/?url='
            this.qrcode_img  = this.qrcode_img + order_sn
            this.is_show = true
        },
        // 关闭核销
        close_qrcode(){
            this.is_show = false
        },
        // 到这里去
        gotoadd(item){
            console.log(item);
            window.location.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${item.latitude},${item.longitude}
            ;title:${item.store_name};addr:${item.store_address};tel:${item.tel}&referer=HFB-hui-yuan-duan`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/yuyuedingdan.vue